import {
  ActionType,
  IFirstSectionResponse,
  IFirstSectionPayload,
} from "models/dashboard/firstSection";

export const getFirstSectionDataAction = (payload: IFirstSectionPayload) => {
  return {
    type: ActionType.GET_FIRST_SECTION_DATA,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.GET_FIRST_SECTION_DATA_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IFirstSectionResponse) => {
  return {
    type: ActionType.GET_FIRST_SECTION_DATA_SUCCESS,
    payload,
  };
};
